export interface AddPropertyError {
  field: 'zipcode' | null;
  message: string;
}

// The API answers with parameter names ("zip is empty", "add_state is missing"), which mean nothing
// to a customer, so its message is never shown as is.
export function getAddPropertyError(err: any): AddPropertyError {
  const apiMessage: string = typeof err?.message === 'string' ? err.message : err?.error?.message || '';
  if (/\bzip\b/i.test(apiMessage)) {
    return { field: 'zipcode', message: 'Please enter the zip code for this address.' };
  }
  if (/\b(address1|address2|add_state)\b/i.test(apiMessage)) {
    return { field: null, message: 'Please pick the full street address from the suggestions.' };
  }
  return { field: null, message: 'We could not add this property. Please check the address and try again.' };
}
